import { Link } from '@tanstack/react-router';
import { DeliveryStatus } from '_/constants/common';
import { Typography, Tag } from 'antd';
import React, { ReactElement } from 'react';

interface Project {
  name?: string;
}

interface Flow {
  name?: string;
  project?: Project;
}

interface Delivery {
  status?: string;
  flow?: Flow;
}

interface DeliverySummaryHeaderProps {
  delivery?: Delivery;
  flow?: Flow;
  linkTo?: string;
}

// Status color mapping
const STATUS_COLORS: Record<string, string> = {
  [DeliveryStatus.OPEN]: '#2196f3', // Blue
  [DeliveryStatus.CLOSED]: '#4caf50', // Green
  [DeliveryStatus.ERROR]: '#f44336', // Red
  [DeliveryStatus.PENDING]: '#ff9800', // Orange
  [DeliveryStatus.PENDING_QUEUE]: '#9e9e9e', // Grey
};

function DeliverySummaryHeader({ delivery, flow, linkTo }: DeliverySummaryHeaderProps): ReactElement {
  const projectName = flow?.project?.name ? flow.project.name : delivery?.flow?.project?.name;
  const flowName = flow?.name ? flow.name : delivery?.flow?.name;
  const status = delivery?.status;

  const titleContent = (
    <Typography.Text type="secondary" style={{ textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.08333em' }}>
      {projectName} - {flowName}
    </Typography.Text>
  );

  return (
    <div style={{ margin: 5 }}>
      {linkTo ? <Link to={linkTo}>{titleContent}</Link> : titleContent}
      {status && STATUS_COLORS[status] && (
        <Tag color={STATUS_COLORS[status]} style={{ marginLeft: '10px' }}>
          {status}
        </Tag>
      )}
    </div>
  );
}

export default DeliverySummaryHeader;
